import { render, staticRenderFns } from "./ImportColumnDialog.vue?vue&type=template&id=74210032&scoped=true"
import script from "./ImportColumnDialog.vue?vue&type=script&lang=js"
export * from "./ImportColumnDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportColumnDialog.vue?vue&type=style&index=0&id=74210032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74210032",
  null
  
)

export default component.exports